import React from 'react'
import PropTypes from 'prop-types'
import { StoryblokComponent } from '@storyblok/react'

import S from './Image.styled'
import Link from '../../../../modules/link/Link'
import { findInArr } from '../../../../utils'

const Image = ({ localData, sbData, imgElement: GatsbyImg, ratio }) => {
  const sbImage = sbData && sbData.img
  const sbImgData = sbImage && findInArr(sbImage, 'component', 'image')

  const sbUrlData = sbData && sbData.url
  const sbUrlTo = sbUrlData && sbUrlData.url
  const sbUrlBlank = sbUrlData && sbUrlData.target === '_blank'

  const localImgData = localData && localData.img
  const sbImgFile = sbImgData && sbImgData.file
  const imgSrc = sbImgFile
    ? sbImgFile.filename
    : localImgData && localImgData.src
  const imgAlt = sbImgFile ? sbImgFile.alt : localImgData && localImgData.alt

  const localUrlData = localData && localData.url
  const localUrlTo = localUrlData && localUrlData.to
  const localUrlBlank = localUrlData && localUrlData.blank
  const urlTo = sbUrlTo ? sbUrlTo : localUrlTo
  const urlBlank = sbUrlBlank ? sbUrlBlank : localUrlBlank

  const ImgEl = () =>
    sbImgData ? (
      <StoryblokComponent blok={sbImgData} className="image" />
    ) : (
      <img src={imgSrc} alt={imgAlt} className="image" loading="eager" />
    )

  return (
    <S.Image ratio={ratio}>
      {urlTo ? (
        <Link to={urlTo} blank={urlBlank || false}>
          {GatsbyImg ? <GatsbyImg /> : <ImgEl />}
        </Link>
      ) : (
        <ImgEl />
      )}
    </S.Image>
  )
}

Image.propTypes = {
  localData: PropTypes.object,
  sbData: PropTypes.object,
  ratio: PropTypes.string.isRequired,
}

export default Image
